import Vue from 'vue'
import { MutationTree } from 'vuex'
import { ApiState } from './types'

export const mutations: MutationTree<ApiState> = {
  SET_ACCESS_TOKEN (state, payload: string) {
    state.accessToken = payload
    if (Vue.prototype.$api) {
      Vue.prototype.$api.accessToken = state.accessToken
    }
  },

  SET_SHOULD_ACCEPT (state, payload: boolean) {
    state.shouldAccept = payload
  },

  SET_ERROR (state, payload: {}) {
    state.errors = {
      ...state.errors,
      ...payload
    }
  }
}
